





































































































import {Component, Vue} from "vue-property-decorator";
import HeroRhizome from "@/components/HeroRhizome.vue";
import TextBox from "@/components/TextBox.vue";
import LogoBox from "@/components/LogoBox.vue";
import PathBox from "@/components/PathBox.vue";
import BackgroundText from "@/components/BackgroundText.vue";
import WordCloud from "@/components/WordCloud.vue";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import {MainPageConfig} from "@/interfaces/main-page.interface";
import Button from "@/components/Button.vue";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";
import ContentPage from "@/components/ContentPage.vue";
import VideoSync from "@/components/VideoSync.vue";
import Quote from "@/components/Quote.vue";
import VideoBox from "@/components/VideoBox.vue";
import ImageGrid from "@/components/ImageGrid.vue";
import VideoContent from "@/components/VideoContent.vue";
import {ThemePathPageConfig} from "@/interfaces/theme-path-page.interface";
import {localStorageService} from "@/services/local-storage.service";
import {LocalStorageServiceConfig} from "@/interfaces/local-storage.interface";

@Component({
  components: {
    WordCloud,
    BackgroundText,
    PathBox,
    LogoBox,
    TextBox,
    HeroRhizome,
    Button,
    ContentPage,
    VideoSync,
    Quote,
    VideoBox,
    ImageGrid,
    VideoContent,
  }
})

export default class MainPage extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  filmViewModes = ThemePathPageConfig.FilmViewModes;

  isLoading = true;

  activeSlide = null;
  bgSrc: string = '';

  blockTypes = MainPageConfig.PageBlockTypes;
  pageContent: MainPageConfig.IMainPageConfig;

  boxOver(imageSrc: string, index: number) {
    this.activeSlide = index;
    this.bgSrc = imageSrc;
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  async openRandomRhizom() {
    let words;
    this.pageContent.content.forEach(block => {
      for (const [key, value] of Object.entries(block)) {
        if (key === 'keyWords') {
          words = value.words;
        }
      }
    })
    let random = this.getRandomInt(words.length);

    localStorageService.pushHistory(
        {
          type: LocalStorageServiceConfig.HistoryItemTypes.KEYWORD,
          keyword: {
            entity_id: words[random].entity_id,
            keyword: words[random].keyword,
          },
        }
    );

    await this.$store.dispatch('rhizome/openRhizomeWithKeyword', {
      keyword: {
        id: Number(words[random].entity_id),
        value: words[random].keyword,
      }
    });
  }

  async created() {
    this.pageContent = await this.$store.dispatch("contentPage/getPageContent", {page: RouterStore.ROUTE_NAME.MAIN_PAGE});
    this.isLoading = false;

    setTimeout( () => {
      bus.$emit(EventEmitter.Events.DATA_LOADED);
    })
  }
}
